import { FetchPermissionsRoutine } from '../redux-routines';
import { loadLocalStoreData} from '../../../services/local-storage.service';

const initialState = {
  isFetching: false,
  permissions: loadLocalStoreData('permissions', [], true),
  error: null
};

export const userAbilitiesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchPermissionsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        permissions: action.payload,
        error: null
      };
    case FetchPermissionsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchPermissionsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};